import fsClient from './firestoreClient';
import {readSearchMarket,matchesMarket} from '../utils/market';
// Non-PA markets are filtered by Firestore. PA includes legacy documents until
// their country backfill is reviewed; never display another market's records.
export async function listMarketBusinesses(db, max = 1000) {
  const code=readSearchMarket().code;
  const where=code==='PA'?[]:[{field:'countryCode',op:'EQUAL',value:code}];
  const rows=await fsClient.listCollectionByPath('businesses',{where,limit:max},{db});
  return (Array.isArray(rows)?rows:[]).filter(b=>matchesMarket(b,code));
}
